import React from 'react';

const ToggleOnIcon = ({size, height, width, color, className, ...props}) => (
    <svg
        width={width ? width : size || "20"}
        height={height ? height : size || "20"}
        fill={color}
        viewBox="0 0 122.88 116.65"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={className}
        {...props}
    >
        <g>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.691,0h51.495c19.631,0,35.691,16.513,35.691,36.695l0,0 c0,20.182-16.062,36.695-35.691,36.695H35.691C16.062,73.391,0,56.877,0,36.695l0,0C0,16.513,16.061,0,35.691,0L35.691,0z M86.183,7.863c16.184,0,29.309,13.125,29.309,29.309S102.366,66.48,86.183,66.48S56.874,53.355,56.874,37.172 S69.999,7.863,86.183,7.863L86.183,7.863z"/>
        </g>
    </svg>
);

export default ToggleOnIcon;